<script>
	import {user, send_data, view} from "../client.svelte.js";
  import {onMount} from "svelte";
	import Sidebar from "../elements/Sidebar.svelte";

  onMount( () => {
	    if (game.ID && view.adventure)
					view.switch_layout('advt-general')
  })

	const difficulties = [
	  {category: "Anfänger", levels: "1 bis 5"},
	  {category: "Fortgeschrittene", levels: "6 bis 10"},
	  {category: "Erfahrene", levels: "11 bis 15"},
	  {category: "Veteranen", levels: "ab 16"} 	]

	/// adventures grouped by their rubric for display in the catalog
	const allGroups = {'NG': "Next Generation", 'WL': "Westländer", 'SF': "Seefahrer", 'CL': "Pentelion Classic",
										 'CI': "Cintaraton", 'ZZ': "Sonstige", 'OR': "The One Ring"}
	let groups = $derived(
		Object.entries(
			Object.groupBy(
				user.adventures.values()
					.toArray()
					.sort((a,b) => a.ID.localeCompare(b.ID))
				,	({rubric}) => rubric) )
			.sort(([a], [b]) => a.localeCompare(b))
			.map(([rubric, advents]) => ({label: allGroups[rubric] ?? rubric, advents})) )

	const cover_URL = (advent) => (advent.cover) ? `/assets/${advent.owner}/.thumbnails/${advent.cover}.jpg` : null

  async function create_adventure() {
	  const confirmed = confirm(`Neue Abenteuer verursachen Aufwand bei der Verwaltung. Bitte nur ein Abenteuer anlegen, wenn das mit dem Admin abgesprochen ist. Bist Du sicher, dass Du das ein Abenteuer anlegen willst?`)
	  if (!confirmed)  return
	  const response = await send_data(`/adventure/_`, {}, 'POST')
    if (response.error) {
      alert(`Es konnte kein Abenteuer angelegt werden. Fehlermeldung: `, response.error)
    } else {
			const advtID = response.adventures[0].ID
	    await user.load_adventure(advtID)
	    view.switch_layout('advt-general')
	    console.log(`ADVENTURE: a new adventure with ID=${advtID} has been created: `, response)
    }
  }

	async function select_adventure(advtID) {
		await user.load_adventure(advtID)
		view.switch_layout('advt-general')
	}

</script>


<!-------------------------------- HTML -------------------------------------->

{#snippet flyout()}
	<p>Herzlich Willkommen im Vorbereitungs-Modul der Pentelion Rollenspiel-App!
		 Hier findest Du alle wichtigen Informationen zur Vorbereitung Deines nächsten Abenteuers.</p>
	<p class="card-meta">Info: Ein Abenteuer ist eine in sich abgeschlossene Geschichte, die an einem oder mehreren Abenden gespielt werden kann.
		 Handelt es sich um eine epischere Erzählung, die sich über mehrere Abenteuer erstreckt, spricht man von einer Kampagne.</p>
	<p>Hier kannst Du aber auch Nicht-Spieler-Charaktere (NSCs) und Schauplätze vorbereiten, die Eure Helden auf ihrer Reise erwarten.</p>
	<h4>Neues Abenteuer</h4>
	<p>Abenteuer sollten prinzipiell auf eine Schwierigkeitsstufe ausgelegt sein, können im Spiel dann später aber noch skaliert werden.</p>
	<table class="dataTable">
		<thead><tr><th>Schwierigkeit</th><th>Heldengrade</th></tr></thead>
		<tbody>
			{#each difficulties as dfclt}
				<tr><td>{dfclt.category}</td><td>{dfclt.levels}</td></tr>
			{/each}
		</tbody>
	</table>
{/snippet}

<section id={view.layout.page}>
	<Sidebar {flyout} items={[
		{id: 'create', icon: 'plus', label: "Abenteuer anlegen", primary: true, onclick: create_adventure},
		{id: 'info', help: 'difficulty', icon: 'info', label: "Einführung", flyout: "Abenteuer"} ]}/>

	<article class="page">
		<div class="intro">
			<span class="card-kicker">Abenteuerübersicht</span>
			<p>Wähle ein vorhandenes Abenteuer aus oder lege ein neues an.</p>
		</div>

		{#each groups as group (group.label)}
			<div class="group">
				<h3>{group.label} <span class="tag neutral">{group.advents.length}</span></h3>
				<div class="tileGrid portrait">
					{#each group.advents as advent (advent.ID)}
						<button class="card tile" title={advent.ID} onclick={() => select_adventure(advent.ID)}>
							<div class="tileImg">
								{#if cover_URL(advent)}
									<img src={cover_URL(advent)} alt={advent.name}>
								{:else}
									<i class="fa icon-image"></i>
								{/if}
							</div>
							<div class="tileBody">
								<span class="card-kicker">{advent.ID}</span>
								<span class="name">{advent.name}</span>
								<span class="card-meta">{[advent.campaigne, advent.region, advent.start].filter(Boolean).join(" · ")}</span>
								{#if advent.teaser}<p class="teaser">{advent.teaser}</p>{/if}
							</div>
						</button>
					{/each}
				</div>
			</div>
		{:else}
			<p class="empty">Du hast noch keine Abenteuer. Lege über die Leiste links ein neues Abenteuer an.</p>
		{/each}
	</article>
</section>


<style lang="sass">
	@use "../colors" as colors

	.intro
		display: flex
		flex-direction: column
		gap: 6px
		max-width: 64ch

		p
			margin: 0
			padding: 0
			font-size: 14px
			line-height: 1.5
			color: colors.$grey-85

	/* portrait cards (2:3) with the body as a plaque over the lower part of the cover */
	.tileGrid.portrait
		grid-template-columns: repeat(auto-fill, minmax(256px, 1fr))

		.tile
			position: relative
			width: 100%
			min-width: 256px
			max-width: 360px
			aspect-ratio: 2 / 3

		.tileImg
			position: absolute
			inset: 0
			aspect-ratio: auto

		.tileBody
			position: absolute
			left: 12px
			right: 12px
			bottom: 12px
			padding: 10px 12px 12px
			border: 1px solid rgba(255, 255, 255, 0.14)
			border-radius: 8px
			background: rgba(0, 0, 0, 0.62)
			backdrop-filter: blur(6px)
			box-shadow: 0 4px 16px rgba(0, 0, 0, 0.45)

			.teaser
				-webkit-line-clamp: 3

	h4
		margin: 8px 0 0
		font-size: 13px
		font-weight: 500

	p
		margin: 0
		padding: 0
		font-size: 13px
</style>
